// extracted by mini-css-extract-plugin
export var btn = "Features-module--btn--27086";
export var btnOutlinePrimary = "Features-module--btn-outline-primary--9baf6";
export var btnPrimary = "Features-module--btn-primary--ac3e5";
export var content = "Features-module--content--62bfa";
export var formSelect = "Features-module--form-select--86669";
export var inner = "Features-module--inner--f85cf";
export var media = "Features-module--media--86637";
export var points = "Features-module--points--c18bf";
export var row = "Features-module--row--3fa7e";
export var rowReversed = "Features-module--rowReversed--f3934";
export var section = "Features-module--section--44aca";
export var sectionHeading = "Features-module--sectionHeading--a8d89";
export var title = "Features-module--title--02dc0";